import React from 'react';
import { Link } from 'react-router-dom';
import AnimatedOwl from './AnimatedOwl';
import { useEffect } from 'react';
import '../styles/components/Hero.scss';

const Hero = () => {
    // No ref needed - using AnimatedOwl component

    const scrollToNextSection = () => {
        // Get the height of the hero section
        const heroSection = document.querySelector('hero-section');
        const heroHeight = heroSection?.offsetHeight || window.innerHeight;
        
        // Scroll to that position smoothly
        window.scrollTo({
            top: heroHeight,
            behavior: 'smooth'
        });
    };

    return (
        
        <section id="hero-home" className="hero-section">
            
            <div className="hero-background"></div>
            <div className="hero-content">
                <div className="logo-animation">
                    <AnimatedOwl />
                    
                </div>

                <h1 className="hero-title">
                    Black <span className="gold-text">owLs</span> NE?
                </h1>

                <div className="hero-subtitle">
                <p>
                            2018'de Kurulan Black owLs Squad takımı, Türkiye'de ve Dünya'da bir çok başarı elde etmiş, uluslararası arenada en tepeyi hedeflemiş bir e-spor organizasyonudur.
                        </p>
                        <p>
                            2024 yılında kurulan Black owLs Community sonrası, e-spor yapısını büyüterek, topluluk çatısı altında geniş bir oyun ekosistemi oluşturmayı amaçladık.                        </p></div>

                <div className="hero-buttons">
                    <a href="#neden-combined" className="gold-button" style={{margin: 'auto'}}>Keşfet</a>
                </div>
            </div>

            <div className="scroll-indicator" onClick={scrollToNextSection} style={{cursor: 'pointer'}}>
                <span>Kaydır</span>
                <div className="scroll-arrow">
                    <span></span>
                    <span></span>
                    <span></span>
                </div>
            </div>
        </section>
    );
};

export default Hero;